export const DriverAssignmentValidation = async ({ vehicles, drivers }) => {
    // console.log(vehicles, drivers)
    // Run validations concurrently
    var validationPromises = [
        ValidateDriverAssignment(vehicles, drivers)
    ];

    const validationResults = await Promise.all(validationPromises);
    var invalidResults = validationResults.filter(result => result?.valid === false);

    return invalidResults;
}

const ValidateDriverAssignment = async (vehicles, drivers) => {
    for (let i = 0; i < vehicles.length; i++) {
        // Other Driver Missing Name
        if (vehicles[i]?.otherDriverSelected == "Yes" && (vehicles[i]?.driverName == "" || vehicles[i]?.driverName == undefined)) {
            return {
                title: "Oops!", message: `Please provide the other driver's first and last name for 
                ${"vehicleYear" in vehicles[i] ?
                        vehicles[i]?.vehicleYear + " " + vehicles[i]?.vehicleMake + " " + vehicles[i]?.vehicleModel :
                        vehicles[i]?.Year + " " + vehicles[i]?.Make + " " + vehicles[i]?.Model}.`,
                valid: false
            };
        }
        // Other Driver Missing DOB
        if (vehicles[i]?.otherDriverSelected == "Yes" && (vehicles[i]?.driverDOB == "" || vehicles[i]?.driverDOB == undefined)) {
            return {
                title: "Oops!", message: `Please provide the other driver's DOB for 
                ${"vehicleYear" in vehicles[i] ?
                        vehicles[i]?.vehicleYear + " " + vehicles[i]?.vehicleMake + " " + vehicles[i]?.vehicleModel :
                        vehicles[i]?.Year + " " + vehicles[i]?.Make + " " + vehicles[i]?.Model}.`,
                valid: false
            };
        }
        // Other Driver Missing DLN
        if (vehicles[i]?.otherDriverSelected == "Yes" && (vehicles[i]?.driverDLN == "" || vehicles[i]?.driverDLN == undefined)) {
            return {
                title: "Oops!", message: `Please provide the other driver's license number for 
                            ${"vehicleYear" in vehicles[i] ?
                        vehicles[i]?.vehicleYear + " " + vehicles[i]?.vehicleMake + " " + vehicles[i]?.vehicleModel :
                        vehicles[i]?.Year + " " + vehicles[i]?.Make + " " + vehicles[i]?.Model}.`,
                valid: false
            };
        }
        // No driver selected for this vehicle
        if (!("driverName" in vehicles[i]) || vehicles[i]?.driverName == '' || vehicles[i]?.driverName == undefined) {
            return {
                title: "Oops!", message: `Please provide a driver for 
                ${"vehicleYear" in vehicles[i] ?
                        vehicles[i]?.vehicleYear + " " + vehicles[i]?.vehicleMake + " " + vehicles[i]?.vehicleModel :
                        vehicles[i]?.Year + " " + vehicles[i]?.Make + " " + vehicles[i]?.Model}.`,
                valid: false
            };
        }
        // Missing Primary/Occasional vehicle selection for vehicles > drivers
        if (vehicles?.length > drivers?.length && vehicles[i]?.driverName != "" && vehicles[i]?.otherDriverSelected != "Yes" && (vehicles[i]?.vehicleType == "" || vehicles[i]?.vehicleType == undefined)) {
            return {
                title: "Oops!", message: `Please determine if this driver is the primary or occasional driver for 
                            ${"vehicleYear" in vehicles[i] ?
                        vehicles[i]?.vehicleYear + " " + vehicles[i]?.vehicleMake + " " + vehicles[i]?.vehicleModel :
                        vehicles[i]?.Year + " " + vehicles[i]?.Make + " " + vehicles[i]?.Model}.`,
                valid: false
            };
        }
        // return { valid: true }
    }

    // More vehicles than drivers on policy
    if (vehicles.length > drivers.length) {
        var count = 0

        // Check that each driver is a primary on any vehicle
        for (var i = 0; i < drivers.length; i++) {
            if (vehicles.some((v) => v.driverName == drivers[i]?.fullName && v?.vehicleType == "Primary")) {
                count += 1;
            }
        }

        // Not all drivers were assigned as a primary driver
        if (count != drivers.length) {
            return { title: "Oops!", message: 'You must select one vehicle as a primary vehicle for each driver to proceed.', valid: false };
        }
        return { valid: true }
    }
}

